import { createStore } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import type { StampcardStore } from "./store.types";

const INITIAL_STATE: StampcardStore = {
  products: null
};

const stampcardStore = createStore<StampcardStore>()(
  immer(devtools(() => INITIAL_STATE, { name: "stampcard-store" }))
);

export { INITIAL_STATE, stampcardStore };
